import { EChartService } from './echart.service';
import { SchoolGroupTrendAnalysis, HumanitiesOrSciences } from '@/models/school-group/school-group-trend-analysis';
import i18n from '@/i18n';

export class TrendanalysisHumanitiesOrSciencesEchartService extends EChartService {
  self: any;
  val: number;
  data: HumanitiesOrSciences;

  constructor() {
    super();
    this.series = [];
    this.labels = [];
  }

  /**
   * AIGROW2-184 箱ひげ図にデータテーブルを追加
   * 箱ひげ図のみにデータを表形式で表示する
   * EChartService が箱ひげ図以外のグラフでも共通なので、空配列を返すだけのものを追加しています
   * subTableColmuns
   * subTableData
   */
  get subTableColmuns(): any[] {
    return [];
  }
  get subTableData(): any[] {
    return [];
  }

  get options() {
    return {
      title: [
        { left: 'center', top: 10, text: i18n.t('NUMANITIES_OR_SCIENCES').toString() },
        {
          show: true,
          text: i18n.t('HUMANITIES').toString(),
          textStyle: {
            color: 'orange',
          },
          bottom: '4%',
          left: '7%',
        },
        {
          show: true,
          text: i18n.t('SCIENCES').toString(),
          textStyle: {
            color: 'blue',
          },
          bottom: '4%',
          right: '7%',
        },
      ],
      legend: {
        data: this.labels,
        top: 100,
        right: 0,
        orient: 'vertical',
      },
      grid: { width: '80%', height: '80%', top: 'auto', left: 'auto' },
      xAxis: [
        {
          type: 'value',
          name: i18n.t('NUMANITIES_OR_SCIENCES').toString(),
          nameLocation: 'center',
          nameTextStyle: { fontWeight: 'bold' },
          nameGap: 15,
          min: -100,
          max: 100,
          axisLabel: {
            // 文系をマイナス値として表示させたくないので、x軸自体表示しない
            show: false,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          // name: '人数', //barチャート出す場合はコメントアウト戻す
          nameLocation: 'center',
          nameTextStyle: { fontWeight: 'bold' },
          nameGap: 30,
          min: 0,
          axisLabel: {
            // y軸自体の目盛りを表示させない
            show: false,
          },
        },
      ],
      series: this.series,
    };
  }

  addSeries(SchoolGroupTrendAnalysis: SchoolGroupTrendAnalysis): void {
    this.data = SchoolGroupTrendAnalysis.humanitiesOrSciences;
    const name: string = `SN-${this.labels.length + 1}`;
    this.labels.push(name);

    this.series.push({
      name: name,
      type: 'line',
      showSymbol: false,
      clip: true,
      data: this.latestNormalDistributionData,
      z: 2,
    });
  }

  normalDistribution(x: number, mean: number, stdDev: number) {
    return (1 / (stdDev * Math.sqrt(2 * Math.PI))) * Math.exp(-0.5 * Math.pow((x - mean) / stdDev, 2));
  }

  generateNormalDistributionData(mean: number, stdDev: number) {
    let data = [];
    for (let i = -100; i <= 100; i += 0.1) {
      data.push([i, this.normalDistribution(i, mean, stdDev)]);
    }
    return data;
  }

  get latestNormalDistributionData() {
    if (this.data.latestMean && this.data.latestStandardDeviation) {
      return this.generateNormalDistributionData(this.data.latestMean, this.data.latestStandardDeviation);
    }
    return [];
  }
}
